<template>
    <div style="width: 70%;margin-left: 10%;margin-top: 30px;">
            <SearchMethodsDetail v-bind:sepaMethods="this.$store.detailForm"></SearchMethodsDetail>
    </div>
</template>

<script>

    import SearchMethodsDetail from './search/SearchMethodsDetail'
    export default {
    name: "SearchSepeMethods",
    components: {
        SearchMethodsDetail
    },
    }
</script>